import { Endpoint } from '../endpoint';
import {
  UserCourseStepResponse,
  UserCourseStepId,
  CourseStepAnswers,
  CourseStepProgressResponse,
  PreviewCourseResponse,
} from '@business/entities/user_course';
import { CourseId } from '@business/entities/course';

export function fetchCourse(id: CourseId) {
  return Endpoint.get<PreviewCourseResponse>(`@gc/courses/preview-course/${id}`);
}

export function stepComplete(id: CourseId, stepId: UserCourseStepId, answers: CourseStepAnswers) {
  return Endpoint.post<UserCourseStepResponse>(`@gc/courses/mark-complete/${id}/${stepId}`, { data: { answers } });
}

export function onProgress(id: CourseId, stepId: UserCourseStepId, progress: CourseStepAnswers) {
  return Endpoint.post<CourseStepProgressResponse>(`@gc/courses/user-progress/${id}/${stepId}`, { data: { progress } });
}
